import { render, staticRenderFns } from "./Bars.vue?vue&type=template&id=a1a50c66"
import script from "./Bars.vue?vue&type=script&lang=js"
export * from "./Bars.vue?vue&type=script&lang=js"
import style0 from "./Bars.vue?vue&type=style&index=0&id=a1a50c66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports